import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './ContactCTA.css';

function ContactCTA() {
  const navigate = useNavigate();

  const handleContactClick = (e) => {
    e.preventDefault();
    navigate('/contact');
    // Scroll to top of the contact page
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="contact-cta">
      <div className="cta-container">
        <h2 className="cta-title">Interested in Learning More?</h2>
        <a href="#" onClick={handleContactClick} className="cta-text-link">
          <span className="cta-text">Please Contact Us</span>
        </a>
      </div>
    </section>
  );
}

export default ContactCTA;
